/**
 * Symbol eines Bereichs (D-00c). `Area.icon` ist der Name eines Lucide-Symbols;
 * aufgeloest wird aus einer kleinen Auswahl (`bereichsSymbole.ts`, nicht aus der
 * ganzen Bibliothek - die wuerde das Bündel um ein Vielfaches vergroessern).
 * Unbekannte Namen zeigen das Standardsymbol.
 */
import { Layers } from 'lucide-react';

import { BEREICHS_SYMBOLE } from '@/modules/areas/bereichsSymbole';

export function BereichsSymbol({ name, className }: { name?: string; className?: string }) {
  const Icon = (name && BEREICHS_SYMBOLE[name]) || Layers;
  return <Icon className={className} aria-hidden="true" />;
}
